export const emptyCircularProgressPresets = {
    size: {
        xs: {},
        sm: {},
        md: {},
        lg: {},
        xl: {},
    },
};
export const emptyLinearProgressPresets = {
    size: {
        sm: {},
        md: {},
        lg: {},
    },
};
//# sourceMappingURL=loadingIndicator.js.map